import ThreePointLight from './ThreePointLight.vue'
import ThreePointLightSetting from './ThreePointLightSettings.vue'

export default ThreePointLight
export { ThreePointLightSetting as settings }
